<rt-confirm-dialog
  [title]="'app.candidate.cv_parse_dialog.title' | translate"
  [variant]="ConfirmDialogVariant.Information"
  [triggerUpdateOnInit]="true"
  [agreeLabel]="'app.common.confirm' | translate"
  [cancelLabel]="'app.common.cancel' | translate"
  [closePayload]="$any(state)"
>
  <p>{{ 'app.candidate.cv_parse_dialog.about_to_set' | translate }}</p>

  <rt-group margin-top-small variant="vertical stacked">
    <rt-radio [hasLensIcon]="true" [checked]="state.parse" (click)="setParse(true)">
      {{ 'app.candidate.cv_parse_dialog.do_parse' | translate }}
    </rt-radio>
    <rt-radio [hasLensIcon]="true" [checked]="!state.parse" (click)="setParse(false)">
      {{ 'app.candidate.cv_parse_dialog.no_parse' | translate }}
    </rt-radio>
  </rt-group>

  <p margin-top-small>
    {{ 'app.candidate.cv_parse_dialog.previous_file_availability' | translate }}
  </p>
</rt-confirm-dialog>
